import React, { useMemo } from 'react';

import { useSmartServiceOrderingFeatureFlag } from 'hooks/appointment/useSmartServiceOrderingFeatureFlag';
import { useAppContext } from 'hooks/context/useAppContext';

import SelectDateComponent from './SelectDate';

// Wrapper component to provide feature flag and config to the class component
const SelectDateWrapper: React.FC<Record<string, unknown>> = (props) => {
  const { isEnabled: isSmartServiceOrderingEnabled } =
    useSmartServiceOrderingFeatureFlag();

  const {
    config: { apiUrlV3 },
    publicUser: { business_token, users },
  } = useAppContext();

  // Memoize all props to ensure stable references and prevent unnecessary re-mounts
  const memoizedProps = useMemo(
    () => ({
      ...props,
      isSmartServiceOrderingEnabled,
      apiUrlV3,
      businessToken: business_token,
      users,
    }),
    [props, isSmartServiceOrderingEnabled, apiUrlV3, business_token, users],
  );

  return (
    <SelectDateComponent
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...memoizedProps}
    />
  );
};

export default SelectDateWrapper;
